<template>
  <in-layout>
    <template slot="content">
      <v-flex xs8>
        <v-card class="my-4 pa-3">
          <v-card-title class="title">
            Nova Intimação
          </v-card-title>
          <v-card-text>
            <v-flex xs8>
              <v-form v-model="valid">
                <!-- Requerimento -->
                <div class="my-3 subheading font-weight-bold">
                  Nº do Processo DocGO
                </div>
                <v-layout>
                  <v-text-field
                    solo
                    clearable
                    v-model="folderNumber"
                    :rules="[validationRules.required]"
                    :loading="loading"
                    persistent-hint
                    label="Buscar pelo código do requerimento"
                    required
                    prepend-inner-icon="mdi-folder-search-outline"
                    @keypress.enter="fetchSubpoenaedApplication($event.target.value)"
                    :readonly="application !== null"
                    :clear-icon-cb="emptyFolderNumberAndApplication"
                  />
                  <v-btn
                    class="ml-3"
                    color="primary"
                    @click="fetchSubpoenaedApplication(folderNumber)"
                    :disabled="application !== null"
                  >
                    <v-icon left>mdi-magnify</v-icon>
                    Buscar
                  </v-btn>
                </v-layout>

                <v-layout column v-if="!loading">
                  <div class="mb-3 subheading font-weight-bold" v-if="application !== null">
                    Requerimento encontrado:
                  </div>
                  <v-card v-if="application !== null" flat>
                    <v-card-text>
                      <v-list two-line>
                        <v-list-tile>
                          <v-list-tile-avatar>
                            <v-icon class="mr-3" color="amber" size="32">mdi-folder-open</v-icon>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <span class="subheading font-weight-bold">{{ folderNumber}}</span>
                            <span class="subheading">
                              {{ application.application_type.acronym }} -
                              {{ application.application_type.name }}
                            </span>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>

                      <v-list three-line>
                        <v-list-tile>
                          <v-list-tile-avatar>
                            <v-icon class="mr-3">mdi-account-card-details</v-icon>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <span class="subheading font-weight-bold">Requerente</span>
                            <span>{{application.person.name}}</span>
                            <span>{{application.person.cpf_cnpj}}</span>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-layout>

                <!-- Descrição e Documentos -->

                <v-layout column v-if="application !== null">
                  <div class="my-3 subheading font-weight-bold">
                    Documentos Intimados ({{ documentsIntimations.length }})
                  </div>
                  <p v-if="documentsIntimations.length === 0">
                    Nenhum documento foi intimado
                  </p>
                  <v-layout v-for="(documentIntimation, index) in documentsIntimations"
                            :key="index"
                            column>

                    <v-card class="elevation-3 mt-3" >
                      <v-toolbar flat>
                        <v-toolbar-title>Documento {{ index + 1 }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                          <v-btn icon flat @click="removeDocumentIntimation(index)">
                            <v-icon>mdi-close-circle-outline</v-icon>
                          </v-btn>
                        </v-toolbar-items>
                      </v-toolbar>
                      <v-text-field
                        class="px-3 mx-3"
                        label="Documento Intimado"
                        :rules="requiredRules"
                        v-model="documentIntimation.document_name"
                      />
                      <v-textarea
                        class="px-3 mx-3"
                        label="Motivo"
                        :rules="requiredRules"
                        v-model="documentIntimation.reason"
                        rows="4"
                      />
                    </v-card>
                  </v-layout>
                  <v-layout align-center justify-end>
                    <v-btn class="primary text-lg-right" @click="newDocumentIntimation()">
                      Adicionar Documento
                    </v-btn>
                  </v-layout>
                </v-layout>

                <v-layout justify-end class="mt-3">
                  <v-btn
                    type="button"
                    @click="$router.push('/admin')"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    type="button"
                    color="success"
                    @click="createSubpoena"
                    :disabled="!isFormValid"
                  >
                    Criar
                  </v-btn>
                </v-layout>
              </v-form>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
    </template>
  </in-layout>
</template>

<script>
import InLayout from '@/layouts/InLayout';
import validationRules from '@/mixins/validation-rules';
// import { pullAllWith, isEqual } from 'lodash';
import ApplicationService from '@/services/applications/ApplicationService';

export default {
  name: 'NewSubpoena',
  mixins: [validationRules],
  components: {
    InLayout,
  },
  data() {
    return {
      application: null,
      requiredRules: [validationRules.required],
      folderNumber: '',
      documentsIntimations: [],
      items: [],
      loading: false,
      processes: [],
      search: '',
      select: null,
      snackbar: { show: false },
      valid: false,
      validationRules,
    };
  },
  methods: {
    newDocumentIntimation() {
      this.documentsIntimations.push({});
    },
    removeDocumentIntimation(index) {
      this.documentsIntimations.splice(index, 1);
    },
    emptyFolderNumberAndApplication() {
      this.folderNumber = '';
      this.application = null;
    },
    fetchSubpoenaedApplication(folderNumber) {
      this.loading = true;
      ApplicationService.fetchSubpoenaedApplication(folderNumber)
        .then(({ data }) => {
          this.application = data;
        })
        .catch((error) => {
          this.emptyFolderNumberAndApplication();
          this.snackbar = {
            show: true,
            message: error.message || 'Nenhum requerimento foi encontrado',
            color: 'red',
          };
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1500);
        });
    },
    // fetchDocuments(val) {
    //   this.$store.dispatch('fetchDocumentTypes', val);
    // },
    // removeDocumentType(document) {
    // const selected = { ...document };
    // const documentTypesIds = [...this.documentTypesIds];
    // this.documentTypesIds = pullAllWith(documentTypesIds, [selected], isEqual);
    // },
    createSubpoena() {
      this.$store.dispatch('setLoadingDialog', true);
      const intimation = {
        documents_intimations: this.documentsIntimations,
      };
      this.$store.dispatch('createSubpoena', { applicationId: this.application.id, intimation })
        .then(() => {
          this.onCreateSubpoenaSuccess();
        })
        .catch((error) => {
          this.onCreateSubpoenaError(error);
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
    onCreateSubpoenaSuccess() {
      setTimeout(() => {
        this.$router.push('/admin/requerimentos/lista');
        this.$store.dispatch('toggleSnackbar', {
          show: true,
          color: 'success',
          message: 'Intimação criada com sucesso!',
          messageIcon: 'mdi-check',
        });
      }, 600);
    },
    onCreateSubpoenaError(error) {
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'error',
        message: error.message || 'Não foi possível criar a intimação',
        messageIcon: 'mdi-alert-outline',
      });
    },
  },
  computed: {
    isFormValid() {
      return this.application !== null && (this.documentsIntimations.length !== 0 && this.valid);
    },
  },
};
</script>
